<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ label | translate }}</mat-label>
  <input
    *ngIf="dropdownList?.length === 0"
    matInput
    [formControl]="formGroup.get(inputControlName)"
    [id]="inputControlName"
    [placeholder]="placeholder | translate"
    [readonly]="readOnly"
  />

  <mat-select
    *ngIf="dropdownList?.length > 0"
    [formControl]="formGroup.get(inputControlName)"
    (selectionChange)="searchSelected.emit($event)"
  >
    <mat-option *ngFor="let policy of dropdownList" [value]="policy">
      {{ policy?.value }} - {{ policy?.name }}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="formGroup.get(inputControlName)?.hasError('required')">
    {{ errorMessage | translate }}
  </mat-error>

  <button
    *ngIf="dropdownList?.length === 0 && !isClearData"
    class="btn-adjust__post-icon"
    type="button"
    mat-button
    matSuffix
    (click)="findSearchList?.emit()"
    [matTooltip]="'Find'"
    [disabled]="isFormDisabled"
  >
    {{ 'Find' }}
  </button>

  <button
    *ngIf="dropdownList?.length > 0 || isClearData"
    class="btn-adjust__post-icon"
    type="button"
    mat-button
    matSuffix
    (click)="clearedSearch.emit()"
    [matTooltip]="'Clear'"
    [disabled]="isFormDisabled || isEditDisabled"
  >
    {{ 'Clear' }}
  </button>
</mat-form-field>
